import { useQuery } from '@tanstack/react-query';
import { listQuotes } from '@/lib/partnerQuotes';
import { PipelineStats } from './QuotesPage';
import jobs from '../partner-jobs/PartnerJobs.module.css';

/** Win rate and quote pipeline on Today (Warren, 21 October 2026): the partner's own, or a rep's and manager's book. */
export function QuotePipelineCard({ onNavigate }: { onNavigate?: (to: string) => void }) {
  const q = useQuery({ queryKey: ['partner-quotes'], queryFn: listQuotes, retry: false, staleTime: 60_000 });
  if (!q.data) return null;
  const p = q.data.pipeline, own = q.data.viewer.permissions.includes('quotes:write');
  if (!own && p.sent === 0 && p.drafts === 0) return null;
  const go = (e: React.MouseEvent) => { e.preventDefault(); if (onNavigate) onNavigate('/sales-quotes'); else window.location.assign('/sales-quotes'); };
  return <section className={jobs.card} aria-label="Quote pipeline">
    <div className={jobs.cardHead}><h2 className={jobs.kicker}>{own ? 'Your quotes' : 'Your partners\' quotes'}</h2>
      <a href="/sales-quotes" onClick={go}>{own ? 'Open quotes →' : 'See the pipeline →'}</a></div>
    {p.sent === 0 && own ? <p className={jobs.hint}>No quotes sent yet. Quoting here is optional; New job never needs one.</p> : <PipelineStats p={p} />}
  </section>;
}
